//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/partners' // @/configurations/content/partners-dark для темной темы

export default {
  logo: {
    image: require('@/assets/logo/logo.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'Mashroom logo'
  },
  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: ' mashroom 2023 Организация и съемка онлайн-мероприятий',
    description: [
      'Наша команда поможет вам создать онлайн- или офлайн-мероприятие любой сложности. С 2019 года мы провели около 300 мероприятий, начиная с небольших, полностью виртуальных, мероприятий, заканчивая сложными многозальными и многодневными форумами и конференциями с участием первых лиц государства и бизнеса. ',
      'Мы помогаем реализовать проекты в сферах обучения, событийного маркетинга и внутренней корпоративной коммуникации. Среди наших клиентов такие известные бренды как Forbes, Дикси, Самокат, ВТБ, Сбер, Росконгресс, Фортум, Мегамаркет, РЖД, Т1, так и небольшие компании или объединения, которым мы помогаем реализовать свои задачи при помощи мероприятий.'
    ],
    date: '15.10.2023',
    time: '10:00-18:00'
  },
  activities: [
    {
      tabName: 'Выберите:', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'AKSuCCUf',
          id: 2084,
          hallName: 'Основной шоурил' // название зала
        },
        {
          hash: 'TJcIEkfO',
          id: 1130,
          hallName: 'Шоурил AIJ'
        }
      ]
    }
  ],
  player: {
    title: 'Наши работы' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Пример расписания' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Это мы', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/image.jpg'), // путь до изображения для блока с картинкой
    items: [
      'Обычно мы сами приезжаем в гости, к вам в офис или на предполагаемую площадку, где будет происходить ваше мероприятие.',
      'Если у вас полностью виртуальное мероприятие, где вы и ваши гости подключаются удаленно, то проект удобно будет обсудить удаленно, на платформах Dion (для клиентов из РФ, которым важно использование отечественного ПО) или Zoom.',
      'Мы располагаем помещением-трансформером, где мы сможем провести очную и результативную рабочую встречу, продемонстрировать наши производственные возможности, работая с контентом на огромном экране.'
    ]
  },
  info: {
    title: 'География нашей работы', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      'Мы предоставляем услуги на всей территории РФ. Для организаций полностью виртуальных мероприятий ограничений по географии нет. ',
      ''
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Наши клиенты' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Mashroom.',
    phone: '+7 926 260 53 22'
  }
}
